import React from 'react'

import { Button } from '@/components/ui/button'

const ErrorPage: React.FC = () => {
	return (
		<div className="flex flex-col gap-4 h-screen items-center justify-center">
			<h1 className="text-4xl font-bold">Something went WRONG!</h1>
			<Button asChild>
				<a href="/">Go Home</a>
			</Button>
		</div>
	)
}

export default ErrorPage
